import { render, staticRenderFns } from "./NewsletterTest.vue?vue&type=template&id=32c47087&"
import script from "./NewsletterTest.vue?vue&type=script&lang=js&"
export * from "./NewsletterTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports